(function () {
  'use strict';

  /* ─── Products mega menu: category → collection handle ─── */
  var HANDLES = {
    'Cases': 'cases',
    'Protection Kits': 'iphone-15-pro-pro-max-smart-slim-x-3-in-1-and-4-in-1-complete-protection-kits',
    'Screen Protectors': 'screen-protector',
    'Earphones': 'basic-usb-c-earphones',
    'Cables': 'cables',
    'Power Banks': 'power-banks-1',
    'Chargers': 'chargers',
    'Car & Travel Adapters': 'smart-car-charger',
    'Stands': 'all-stands-1'
  };

  var cache = {};

  /* ─────────────────────────────────────────────────────────
     1.  HOVER-OPEN / CLICK-NAVIGATE for ALL mega menus
  ───────────────────────────────────────────────────────── */
  function setupHoverBehaviour() {
    var megaDetails = document.querySelectorAll('details.mega-menu');
    megaDetails.forEach(function (details) {
      var summary  = details.querySelector('summary');
      var navUrl   = details.getAttribute('data-url');
      var openTimer, closeTimer;

      /* Open on mouse-enter (80 ms intent delay) */
      details.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { details.open = true; }, 80);
      });

      /* Close on mouse-leave (120 ms grace period) */
      details.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { details.open = false; }, 120);
      });

      /* Click the summary label → navigate to the top-level URL */
      if (summary && navUrl) {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          details.open = false;
          window.location.href = navUrl;
        });
      }
    });
  }

  /* ─────────────────────────────────────────────────────────
     2.  ACEFAST-style Products panel (sidebar + product cards)
  ───────────────────────────────────────────────────────── */
  function findProductsMega() {
    var all = document.querySelectorAll('details.mega-menu');
    for (var i = 0; i < all.length; i++) {
      var span = all[i].querySelector('summary span');
      if (span && span.textContent.trim() === 'Products') return all[i];
    }
    return null;
  }

  function buildProductsPanel(mega) {
    var content = mega.querySelector('.mega-menu__content');
    var list    = mega.querySelector('.mega-menu__list');
    if (!content || !list) return;

    content.classList.add('bk-mega--wrap');
    list.classList.add('bk-mega-sidebar');

    var panel = document.createElement('div');
    panel.className = 'bk-mega-panel';
    panel.innerHTML = '<div class="bk-mega-grid"></div><div class="bk-mega-footer"></div>';
    content.appendChild(panel);

    var links = list.querySelectorAll('.mega-menu__link--level-2');

    function activate(link) {
      links.forEach(function (l) { l.classList.remove('bk-active'); });
      link.classList.add('bk-active');
      var title  = link.textContent.trim();
      var handle = HANDLES[title];
      if (handle) fetchProducts(handle, title, panel);
    }

    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () { activate(link); });
    });

    /* Pre-load first category when the panel opens */
    mega.addEventListener('toggle', function () {
      if (mega.open && links.length) {
        links.forEach(function (l) { l.classList.remove('bk-active'); });
        activate(links[0]);
      }
    });
  }

  function fetchProducts(handle, title, panel) {
    var grid   = panel.querySelector('.bk-mega-grid');
    var footer = panel.querySelector('.bk-mega-footer');

    footer.innerHTML =
      '<a href="/collections/' + handle + '" class="bk-mega-all-btn">All ' + title + ' →</a>';

    if (cache[handle]) { renderProducts(cache[handle], grid); return; }

    grid.innerHTML = '<span class="bk-mega-loading">Loading…</span>';
    fetch('/collections/' + handle + '/products.json?limit=6')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        cache[handle] = d.products || [];
        renderProducts(cache[handle], grid);
      })
      .catch(function () { grid.innerHTML = ''; });
  }

  function renderProducts(products, grid) {
    if (!products.length) {
      grid.innerHTML = '<p class="bk-mega-empty">No products found.</p>';
      return;
    }
    grid.innerHTML = products.slice(0, 6).map(function (p) {
      var img = p.images && p.images[0]
        ? '<img src="' + p.images[0].src + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
        : '<div class="bk-mega-no-img"></div>';
      return (
        '<a href="/products/' + p.handle + '" class="bk-mega-card">' +
        '<div class="bk-mega-img">' + img + '</div>' +
        '<div class="bk-mega-name">' + p.title + '</div>' +
        '</a>'
      );
    }).join('');
  }

  /* ─────────────────────────────────────────────────────────
     3.  COLLAPSIBLE FILTER SIDEBAR
  ───────────────────────────────────────────────────────── */
  function setupFilterToggle() {
    /* Dawn vertical: aside.facets-wrapper > div.facets-container */
    var container = document.querySelector('.facets-container');
    if (!container) return;

    var chevron = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bk-filter-toggle';
    btn.innerHTML = chevron + '<span>Show Filters</span>';

    /* Insert as very first item in the sort bar form — left edge, same line as Sort By */
    var sortForm = document.querySelector('#FacetSortForm');
    if (sortForm) {
      sortForm.insertBefore(btn, sortForm.firstChild);
    } else {
      container.parentNode.insertBefore(btn, container);
    }

    /* Collapse all filter group <details> on init */
    container.querySelectorAll('details').forEach(function (d) {
      d.removeAttribute('open');
    });

    /* Filters hidden by default */
    container.classList.add('bk-hidden');
    btn.classList.add('collapsed');

    btn.addEventListener('click', function () {
      var hidden = container.classList.toggle('bk-hidden');
      btn.classList.toggle('collapsed', hidden);
      btn.querySelector('span').textContent = hidden ? 'Show Filters' : 'Hide Filters';
    });
  }

  /* ─────────────────────────────────────────────────────────
     4.  STICKY HEADER — force "always" via JS as CSS fallback
  ───────────────────────────────────────────────────────── */
  function forceSticky() {
    var hw = document.querySelector('sticky-header, .header-wrapper');
    if (!hw) return;
    /* Ensure the element is wrapped in a sticky-header custom element */
    if (hw.tagName.toLowerCase() !== 'sticky-header') {
      /* settings_data.json didn't apply; apply the style directly */
      hw.style.position = 'sticky';
      hw.style.top = '0';
      hw.style.zIndex = '100';
      hw.style.width = '100%';
    }
    /* If already sticky-header but in on-scroll-up mode, switch to always */
    if (hw.dataset && hw.dataset.stickyType === 'on-scroll-up') {
      hw.dataset.stickyType = 'always';
    }
  }

  /* ─────────────────────────────────────────────────────────
     4.  INIT
  ───────────────────────────────────────────────────────── */
  function init() {
    setupHoverBehaviour();
    var productsMega = findProductsMega();
    if (productsMega) buildProductsPanel(productsMega);
    forceSticky();
    setupFilterToggle();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
